<app-confirm-dialog></app-confirm-dialog>
<!-- START Top Navbar-->
<nav class="navbar topnavbar" role="navigation">
    <!-- START navbar header-->
    <div class="navbar-header">
        <a class="navbar-brand d-flex align-items-center justify-content-center" routerLink="/home">
            <div class="brand-logo">
                <img class="img-fluid" src="assets/img/Logo- Horizontal.png" alt="App Logo" />
            </div>
            <div class="brand-logo-collapsed">
                <img class="img-fluid" src="assets/img/180X180-Favicon_With Biometrics.png" alt="App Logo" />
            </div>
        </a>
    </div>
    <!-- END navbar header-->
    <!-- START Left navbar-->
    <ul class="navbar-nav mr-auto flex-row">
        <li class="nav-item">
            <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
            <a class="nav-link d-none d-md-block d-lg-block d-xl-block" trigger-resize=""
                (click)="toggleCollapsedSideabar()" *ngIf="!isCollapsedText()">
                <em class="fas fa-bars"></em>
            </a>
            <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->
            <a class="nav-link sidebar-toggle d-md-none"
                (click)="settings.toggleLayoutSetting('asideToggled'); $event.stopPropagation()">
                <em class="fas fa-bars"></em>
            </a>
        </li>
        <!-- START User avatar toggle-->
        <!--
            Shown whenever a subscriber is in context, NOT only to admins. This used to be
            *ngIf="role == 'admin'", which happened to work only because getSubscriberDetails()
            set role='admin' as a side effect of looking the company name up — the same side
            effect that handed every subscriber the admin-only "Switch to Admin" control.
            Naming the subscriber is informational; switching to admin is a privilege. They
            are gated separately now: this on having a company, the switch icon on the role.
            (The duplicate banner lower in this file is .roles { display:none } above 750px,
            so on desktop this is the only one.)
        -->
        <li class="nav-item d-none d-md-flex align-items-center" *ngIf="companyName">
            <span class="subscriber-title-badge" [title]="'Subscriber: ' + companyName">Subscriber: {{companyName}}</span>
        </li>
        <!-- END User avatar toggle-->

    </ul>
    <!-- END Left navbar-->

    <div class="navbar-nav flex-row align-items-center ps-gs-header-slot">
        <app-global-search class="w-100"></app-global-search>
    </div>

    <!-- START lock screen-->
    <ul class="navbar-nav flex-row align-items-center ml-auto flex-nowrap">

        <li class="nav-item d-flex align-items-center mx-2 order-report-nav-item">
            <button type="button" class="btn order-report-header-btn" (click)="openOrderReport()" title="Order Report">
                <span class="btn-text">Order Report</span>
            </button>
        </li>
        
        <li class="nav-item dropdown dropdown-list" *ngIf="role == 'admin'" dropdown>
            <a (click)="switchAdmin()" style="cursor: pointer;" title="Switch to Admin"
                class="nav-link dropdown-toggle dropdown-toggle-nocaret" dropdownToggle>
                <em class="icon-shuffle"></em>
            </a>
        </li>

        <app-live-notifications audience="subscriber"></app-live-notifications>

        <!-- START lock screen-->
        <li class="nav-item dropdown dropdown-list d-flex align-items-center userStart" dropdown>
            <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" dropdownToggle style="cursor: pointer;"
                role="button" aria-haspopup="true" aria-label="Account menu">
                <div class="user-profile-badge" [title]="fullName">
                    <span class="avatar-circle">{{userInitials}}</span>
                    <span class="user-name">{{fullName | titlecase}}</span>
                </div>
            </a>
            <!-- START Dropdown menu-->
            <div *dropdownMenu class="dropdown-menu dropdown-menu-right animated fadeIn ps-account-dropdown">
                <a class="dropdown-item" style="cursor: pointer;" (click)="navigateTo2StepAuth()">
                    <em class="fas fa-unlock"></em>
                    <span>Account Details</span>
                </a>
                <a class="dropdown-item" style="cursor: pointer;" (click)="subscriberLogout()">
                    <em class="fas fa-user-lock"></em>
                    <span>Logout</span>
                </a>
            </div>
            <!-- END Dropdown menu-->
        </li>
        <!-- END lock screen-->

        <!-- END Offsidebar menu-->
    </ul>
    <!-- END Right Navbar-->

    <app-navsearch [visible]="getNavSearchVisible()" (onclose)="setNavSearchVisible(false)"></app-navsearch>

    <a class="nav-link roles">
        <h4 style="color: black; margin: 0px !important;">Subscriber: {{companyName}}</h4>
    </a>

</nav>
<!-- END Top Navbar-->